






















































import BaseFilter from '@/components/Filter/BaseFilter';
import {EmailDetailEventsFilterParams} from "@/store/email/statistic/types";
import {Component, Prop, PropSync, Watch} from "vue-property-decorator";
import { DatePickerWings, FastDateDetailWings, FilterWings, SelectWings, FilterSelectedItemWings } from "wings-ui-components";
import { beginningOfCurrentDay, currentDateEnd, dateFilter } from "@/utils/date-util";
import { Action, Getter } from "vuex-class";
import {notifyError} from '@/utils/notify-helper';
import {getTranslatedParams} from "@/utils/notify-utils";

@Component({
  components: {FilterWings, FastDateDetailWings, DatePickerWings, SelectWings, FilterSelectedItemWings},
  filters: {dateFilter}
})
export default class EmailEventsDetailFilter extends BaseFilter<EmailDetailEventsFilterParams> {
  @Prop() readonly createDate!: string;
  @PropSync("filterClone") propFilterClone!: EmailDetailEventsFilterParams;
  @PropSync("runFilter") propRunFilter!: boolean;
  @Getter("eventTypeList") eventTypeList!: string[];

  @Action("getEmailDetailEvents") actionGetItems: any;
  @Action("exportEmailDetailEvents") actionExport: any;
  @Action("actionLog") actionLog: any;

  defaultFilter(): EmailDetailEventsFilterParams {
    return new EmailDetailEventsFilterParams(
        this.createDate || beginningOfCurrentDay(),
        currentDateEnd()
    );
  }

  async onFilteredAction() {
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: 'success',
        object_type: "Detail events statistics",
        addititional_info: getTranslatedParams(this.filter, {
          type: 'event_type'
        })
      }
      await this.actionGetItems({id: this.$route.params.id, filter: this.filter})
      await this.actionLog(this.logObject)
    } catch(error) {
      await this.actionLog({...this.logObject, actionStatus: 'failed'})
      notifyError(error);
    }
  }

  async doActionExport(filter: EmailDetailEventsFilterParams): Promise<any> {
    return await this.actionExport({id: this.$route.params.id, filter: filter});
  }

  @Watch('filter', {immediate: true, deep: true})
  onFilterChange(val: EmailDetailEventsFilterParams) {
    this.propFilterClone = val;
  }

  @Watch('runFilter', { immediate: true })
  onRunFilterChange(val: boolean) {
    if (val) {
      this.filtered();
      this.propRunFilter = false;
    }
  }

  @Watch('createDate', { immediate: true })
  onCreateDateChanged(newVal: string | null) {
    if (newVal) {
      this.filter.date_from = this.createDate;
      this.sendFilter.date_from = this.createDate;
      this.onFilteredAction();
    }
  }
}
